export default {
  REQUEST_ALL_COURSES(state) {
    state.statusAllCourses = "loading";
  },
  SUCCESS_ALL_COURSES(state, value) {
    state.statusAllCourses = "success";
    state.allCourses = value;
  },
  FAILED_ALL_COURSES(state) {
    state.statusAllCourses = "failed";
  },
  SUCCESS_COURSE_DETAILS(state, { index, data }) {
    const allCourses = state.allCourses;
    allCourses[index].Bookings = data;
    state.allCourses = allCourses;
  },
  REQUEST_TOKEN(state) {
    state.statusToken = "loading";
  },
  SUCCESS_TOKEN(state, value) {
    state.statusToken = "success";
    localStorage.setItem("authToken", value);
  },
  FAILED_TOKEN(state) {
    state.statusToken = "failed";
  },
  REQUEST_BOOK_COURSE(state) {
    state.statusBookCourse = "loading";
  },
  SUCCESS_BOOK_COURSE(state, value) {
    state.statusBookCourse = "success";
    state.bookCourse = value;
  },
  FAILED_BOOK_COURSE(state) {
    state.statusBookCourse = "failed";
  },
};
